var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"bb-basket-mini\">\n<span class=\"fa fa-shopping-cart pull-right\" ng-class=\"{'disabled-cart': bb.current_page == 'basket'}\" ng-click=\"showBasketDetails()\">\n<span ng-show=\"basketItemCount\" class=\"badge badge-notify\">\n{{basketItemCount}}\n</span>\n</span>\n</div>\n";
var id1="public-booking/basket/basket_mini.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/basket/basket_mini.html
// module id = 1214
// module chunks = 0